




















































import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '../../mixins/pagination'
import { SearchItemType, TableColumnItemType, OperationItemType } from '../../types/type'
import { CommonModule, UserModule } from '../../store'
import { getAllFatherNodeForTree, disposeSearchParamsForCM, getArrChildForTree } from '../../utils/toolsForCommon'
@Component({
  name: 'Disinfect',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../components/common/searchModule.vue'),
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../components/common/tableModule.vue')
  }
})
export default class Disinfect extends Vue {
  public loading = false
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '学校',
      key: 'organizationNameForDisinfect',
      type: 'cascader',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      show: true,
      disabled: true
    },
    {
      title: '消杀时间',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择时间',
      show: true,
      disabled: false
    },
    {
      title: '消杀方式',
      key: 'mode',
      type: 'input',
      value: '',
      placeholder: '请输入消杀方式',
      show: true,
      disabled: false
    },
    {
      title: '消杀时长或药品配比',
      key: 'info',
      type: 'input',
      value: '',
      placeholder: '请输入消杀时长或药品配比',
      show: true,
      disabled: false
    },
    {
      title: '消杀人员',
      key: 'operator',
      type: 'input',
      value: '',
      placeholder: '请输入消杀人员',
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '乡镇',
      key: 'townStr',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '学校',
      key: 'school',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum',
      width: '200px'
    },
    {
      title: '消杀时间',
      key: 'time',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '消杀方式',
      key: 'mode',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '消杀时长或药品配比',
      key: 'info',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '消杀人员',
      key: 'operator',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '消杀图片',
      key: 'picture',
      type: 'imageList',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '备注',
      key: 'comment',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '删除',
      key: 'delete',
      type: 'danger',
      size: 'mini'
    }
  ]

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.getTableDataList()
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'organizationNameForDisinfect':
          item.treeData = this.treeDataForSubOrganatizion
          // item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          // // 有学校的话就默认勾选第一所：
          // const arrChildForTree = getArrChildForTree(this.treeDataForSubOrganatizion, 'children')
          // let firstSchool: any = ''
          // if (arrChildForTree.length) {
          //   firstSchool = arrChildForTree[0]
          //   item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', firstSchool.id)
          // }
          break
      }
      return item
    })
  }

  operationForAddOrUpdate (id: string) {
    this.$router.push({
      name: 'AddOrUpdateDisinfect',
      query: {
        id
      }
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    const { id, outOrIn } = row
    switch (key) {
      case 'delete':
        this.operationForDelete(id)
        break
    }
  }

  // 删除：
  operationForDelete (id: string) {
    this
      .$confirm('确定要删除此消杀记录吗?', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消删除',
        type: 'error'
      })
      .then(async () => {
        let { data: result } = await (this as any).$http.dailyDisinfectDel({ id })
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('删除成功！')
        this.getTableDataList()
      })
      .catch(() => {})
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams
      }
      const { data: result } = await (this as any).$http.dailyDisinfectQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item.time = (item.time || '暂无').split(' ')[0]
        item.picture = item.picture ? item.picture.split(',') : []
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        // case 'organizationNameForDisinfect':
        //   item.treeData = this.treeDataForSubOrganatizion
        //   item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
        //   // 有学校的话就默认勾选第一所：
        //   const arrChildForTree = getArrChildForTree(this.treeDataForSubOrganatizion, 'children')
        //   let firstSchool: any = ''
        //   if (arrChildForTree.length) {
        //     firstSchool = arrChildForTree[0]
        //     item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', firstSchool.id)
        //   }
        //   break
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }
}
